import {Component, OnInit, ViewChild, ViewContainerRef, Inject} from '@angular/core';
import { MdDialog, MdDialogRef, MdDialogConfig, MD_DIALOG_DATA } from '@angular/material';
import {UserService} from '../../../../services/users-service/user-service';
import {Router} from '@angular/router';
import {MdCheckbox, MdSnackBar} from '@angular/material';
import {AuthService} from '../../../../services/auth-service/auth-service.service';
import {ErrorService} from '../../../../util/error_service/error.service';
import {SharedService} from '../../../../services/shared-service/shared.service';
import {ToastService} from '../../../../util/toast-service/toast.service';
import '../../../../util/custom-alert/custom-alert.component';

@Component({
  selector: 'app-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.scss']
})

export class ManageUsersComponent implements OnInit {
  userData: any;

  p = 1;


  public agentWithId = [];
  public newAgentWithId = [];

  public setId = null;
  public searchText = '';
  public firstname = '';
  public lastname = '';
  public walletBalance = 0;
  public isBlocked: boolean;
  public isFreezed: boolean;
  public agents: any;
  public isloading: boolean;
  public isLoadingAgents: boolean;
  public errorResponse: any;
  public fundedMessage: string;
  public searchInput: string;

  public isActiveTicked: boolean;
  public isBlockedTicked: boolean;

  pageTitle = 'Manage Agents';

  dialogRef: MdDialogRef<DialogResultComponent>;


  constructor( public dialog: MdDialog, private agentService: UserService, private router: Router,
              private authService: AuthService, private error: ErrorService, private sharedService: SharedService,
              private toast: ToastService) {
    this.sharedService.emitChange(this.pageTitle);
    this.isLoadingAgents = false;
    this.fundedMessage = '';
    this.searchInput = '';
    this.getAllAgents(true);

    this.isActiveTicked = true;
    this.isBlockedTicked = true;
  }

  ngOnInit() {
  }



// get agent id
  getUserDetails(userId, userStatus, walletBalance, firstName, lastName): void {
    this.setId = userId;
    this.isBlocked = userStatus;
    this.walletBalance = walletBalance;
    this.firstname = firstName;
    this.lastname = lastName;
  }
// view profile
  viewProfile(id ?: number) {
    if (id){
      this.router.navigate(['admin/agent/' + id + '/account' ]);
      return;
    }
      this.router.navigate(['admin/agent/' + this.setId + '/account' ]);
      this.sharedService.selectedMenu('one');
  }

  // View Agents
  viewUserAgents() {
    this.sharedService.selectedMenu('three');
    this.router.navigate(['admin/agent/' + this.setId + '/user-agents'])
  }


// block user
  blockUser = () => {
    this.isloading = true;
    const userId = this.setId;
    // console.log('Block user:' + userId);
    this.agentService.blockUser(this.setId).subscribe(
      data => {
        // console.log(data);
        this.getAllAgents(false);
        this.isloading = false;
        this.toast.showSuccess('Agent  blocked successfully', 'Success');
      },
      err => {
        // console.log(err);
        const msg = this.error.errorHandlerWithText(this.blockUser, err);
        this.toast.showError(msg.message, 'Error');
      }
    )
  }


// unblock user
  unBlockUser = () => {
    this.isloading = true;
    const userId = this.setId;
    // console.log('Block user:' + userId);
    this.agentService.unblockUser(this.setId).subscribe(
      data => {
        // console.log(data);
        this.getAllAgents(false);
        this.isloading = false;
        this.toast.showSuccess('Agent unblocked successfully', 'Success');
      },
      err => {
        // console.log(err);
        // if error response is due to expired token
        const msg = this.error.errorHandlerWithText(this.unBlockUser, err);
        this.toast.showError(msg.message, 'Error');      }
    )
  }


  confirmDelete = () => {
     const deleteAction = confirm('Are you sure you want to delete this Agent ?');
    if (deleteAction == true){
      this.deleteUser();
    }else{
      return false
    }
  }

// delete agent
  deleteUser = () => {

    this.isloading = true;
    const userId = this.setId;
    // console.log(`Delete user:${userId}`);
    this.agentService.deleteUser(this.setId).subscribe(
      data => {
        // console.log(data);
        this.getAllAgents(false);
        this.isloading = false;
        this.toast.showSuccess('Agent Successfully Deleted', 'Success');
      },
      err => {
        // console.log(err);
        const msg = this.error.errorHandlerWithText(this.deleteUser, err);
        this.toast.showError(msg.message, 'Error');      }
    )
  }



  // converted this to a pipe
  onFilterAgent = () => {
    let newAgentList;
    const oldList = this.agentWithId;
    // console.log(this.searchInput);
    const searchText = this.searchInput.toLowerCase();
    // console.log(searchText);

    newAgentList = this.agentWithId.filter( (agent) => {
      return agent.data.firstName.toLowerCase().includes(searchText);
    });
    // console.log(newAgentList);
  }


  // Sort data ////////////////////

  ////////////////// get all agents info ////////////////////////////////////////////////////
  getAllAgents = (newLoad = false) => {
    if (newLoad) {
      this.isLoadingAgents = true;
    } else {
      this.isLoadingAgents = false;
    }
    this.agentService.getAgents().subscribe(
      response => {
        console.log('************ Agents list ****************');
        console.log(response.data);
        this.agents = response.data.filter(agents => agents.deleted !== 1);
        this.agents.sort(function(a, b) {
          return - ( a.id - b.id  ||  a.name.localeCompare(b.name) );
        });
        this.isLoadingAgents = false;
        this.getAgentWithId();
      },
      err => {
        // console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.getAllAgents, err);
        this.isLoadingAgents = false;
        // console.log(this.errorResponse);

      }
    )
  }


  // Sort data ////////////////////
  getAgentWithId() {
    this.agentWithId = [];
    for (let i = 0; i < this.agents.length; i++ ) {
      const sortedAgents: any = {id: 0, data: {}};
      sortedAgents.id = i + 1;
      sortedAgents.data = this.agents[i];
      this.agentWithId.push(sortedAgents);
      this.newAgentWithId.push(sortedAgents);
      this.isLoadingAgents = false;
    }
    // console.log("Agent with id");
    // console.log(this.agentWithId);
  }

  getAgentData(data: any){
    this.userData = data;
    this.setId = data.id;
    this.isBlocked = data.blocked;
    this.isFreezed = data.freezedAmount > 0 ? true : false;
  }

  fundDialog() {
    // console.log("userdata", this.userData);

    const dialogRef = this.dialog.open(DialogResultComponent, {
      height: '280px',
      width: '400px',
      data: {
        userId: this.userData.id,
        walletBalance: this.userData.walletBalance,
        firstName: this.userData.firstName,
        lastName: this.userData.lastName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'close'){
        return false;
      }
      const message = result.firstname + '\'s wallet was credited with ₦' + result.amount + ' successfully';
      this.fundedMessage = message;
      this.toast.showSuccess(message, 'Wallet Credited');
      this.getAllAgents(false);
    });

    if (this.fundedMessage != ''){
      // console.log('not empty');
    }
  }

  freezeDialog() {
    // console.log("userdata", this.userData);

    const dialogRef = this.dialog.open(FreezeAccountComponent, {
      // height: '280px',
      width: '400px',
      data: {
        userId: this.userData.id,
        walletBalance: this.userData.walletBalance,
        firstName: this.userData.firstName,
        lastName: this.userData.lastName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'close'){
        return false;
      }
      const message = '₦' + result.freezeAmount + ' is frozen from ' + result.firstname + ' account successfully';
      this.fundedMessage = message;
      this.toast.showSuccess(message, 'Account Frozen');
      this.getAllAgents(false);
    });

    if (this.fundedMessage != ''){
      // console.log('not empty');
    }
  }


  walletTransferDialog() {
    const dialogRef = this.dialog.open(WalletTransferComponent, {
      height: '280px',
      width: '400px',
      data: {
        userId: this.userData.id,
        walletBalance: this.userData.walletBalance,
        walletCommissionBalance: this.userData.walletCommissionBalance,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'close'){
        return false;
      }
      // this.fundedMessage = message;
      this.toast.showSuccess('Fund Transfer', result.message);
      console.log('**');
      this.getAllAgents(false);
    });

    if (this.fundedMessage != ''){
      // console.log('not empty');
    }
  }
}



@Component({
  selector: 'dialog-result',
  styles: [ '.user-details { margin-bottom: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;}',
    '.user-details span{ color:#444; text-transform:uppercase; text-overflow:ellipsis}',
    '.wallet { font-weight: normal; padding:2px 5px; border-radius:5px;text-align: center;} background-color:#ededed; display: inline-block;} '],
  templateUrl: 'dialog-result.html',
})
export class DialogResultComponent {

  public firstName: string;
  public lastName: string;
  public userId: number;
  public walletBalance: number;
  public amount: number;


  constructor(
    public dialogRef: MdDialogRef<DialogResultComponent>, private agentService: UserService, private error: ErrorService,
    @Inject(MD_DIALOG_DATA) public data: any) {
    this.userId = this.data.userId;
    this.firstName = this.data.firstName;
    this.lastName = this.data.lastName;
    this.walletBalance = this.data.walletBalance;
    this.amount = null;
  }




  fundAgent = () => {

    const fundMessage = {funded: false, amount: 0, firstname : ''}

    this.agentService.fundWallet(this.userId, this.amount).subscribe(
      data => {
        fundMessage.funded = true;
        fundMessage.amount = this.amount;
        fundMessage.firstname = this.firstName;
        // console.log(data);
        this.dialogRef.close(fundMessage);
      },
      err => {
        // console.log(err);
        const msg = this.error.errorHandlerWithText(this.fundAgent, err);
      }
    )
  }


}


@Component({
  selector: 'freeze-account',
  styles: [ '.user-details { margin-bottom: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;}',
            '.user-details span{ color:#444; text-transform:uppercase; text-overflow:ellipsis}',
            '.wallet { font-weight: normal; padding:2px 5px; border-radius:5px;text-align: center;} background-color:#ededed; display: inline-block;} '],
  templateUrl: 'freeze-account.html',
})
export class FreezeAccountComponent {
  isFreezing: boolean;

  public firstName: string;
  public lastName: string;
  public userId: number;
  public walletBalance: number;

  public freezeAmount: number;
  public freezeReason: string;
  public freezeObj: any = {
    'amount': null,
    'reason': null,
    'userId': null
  }


  constructor(
    public dialogRef: MdDialogRef<DialogResultComponent>, private agentService: UserService, private error: ErrorService,
    @Inject(MD_DIALOG_DATA) public data: any) {
    this.userId = this.data.userId;
    this.firstName = this.data.firstName;
    this.lastName = this.data.lastName;
    this.walletBalance = this.data.walletBalance;

    this.freezeAmount = null;
    this.freezeReason = null;

    this.isFreezing = false;
  }




  freezeAccount = () => {

    this.freezeObj.userId = this.userId;
    this.freezeObj.amount = this.freezeAmount;
    this.freezeObj.reason = this.freezeReason;
    this.isFreezing = true;

    // console.log('freeze obj',this.freezeObj);


    const freezeMessage = {freezed: false, freezeAmount: 0, firstname : ''}

    this.agentService.freezeAccount(this.freezeObj).subscribe(
      data => {
        freezeMessage.freezed = true;
        freezeMessage.freezeAmount = this.freezeAmount;
        freezeMessage.firstname = this.firstName;

        this.isFreezing = false;
        // console.log(data);
        this.dialogRef.close(freezeMessage);
      },
      err => {
        // console.log(err);
        const msg = this.error.errorHandlerWithText(this.freezeAccount, err);
      }
    )
  }


}



@Component({
  selector: 'app-wallet-transfer',
  styles: [ '.user-details { margin-bottom: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;}',
    '.user-details span{font-size:1rem; font-weight: 600; color:#444; text-transform:uppercase; text-overflow:ellipsis}',
    '.wallet {font-size:1.2rem; font-weight: 500; padding:2px 5px; border-radius:5px;text-align: center; background-color:#ededed; display: inline-block;} '],
  templateUrl: 'wallet-transfer.html',
})
export class WalletTransferComponent {
  isTransferringFund: boolean;

  public userId: number;
  public walletBalance: number;
  public walletCommissionBalance: number;
  public transferAmount: number;
  public transferAllStatus = false;

  constructor(
    public dialogRef: MdDialogRef<WalletTransferComponent>, private agentService: UserService, private toast: ToastService, private error: ErrorService,
    @Inject(MD_DIALOG_DATA) public data: any) {
    this.userId = this.data.userId;
    this.walletBalance = this.data.walletBalance;
    this.walletCommissionBalance = this.data.walletCommissionBalance;
    this.isTransferringFund = false;
  }

  transferFund = () => {
    if (this.transferAmount == 0) {
      this.toast.showWarning('Transfer amount cannot be empty', '');
      return false;
    }
    if (this.walletCommissionBalance == 0) {
      this.toast.showWarning('Your commission wallet is empty', '');
      return false;
    }
    if (this.transferAmount > this.walletCommissionBalance) {
      this.toast.showWarning('Transfer amount cannot be greater than balance', '');
      return false;
    }

    this.isTransferringFund = true;
    this.agentService.transferCommissionToMain(this.userId, this.transferAmount).subscribe(
      data => {
        this.isTransferringFund = false;
        this.transferAmount = null;
        this.dialogRef.close(data);
      },
      err => {
        console.log('#', err);
        this.isTransferringFund = false;
        const msg = this.error.errorHandlerWithText(this.transferFund, err);
        console.log(msg);
      }
    )
  }

  transferAllFunds = () => {
    this.transferAllStatus = !this.transferAllStatus;
    this.transferAmount = this.transferAllStatus ? this.walletCommissionBalance : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/User management/manage-agents/manage-users.component.ts